import classNames from 'classnames';
import { XMarkIcon } from '@heroicons/react/16/solid';
import { OnlineOrderTagDef } from './online-order-tags';

interface Props {
  tag: OnlineOrderTagDef;
  size?: 'sm' | 'md';
  // When provided, the badge renders a small × that calls this handler.
  onRemove?: () => void;
  disabled?: boolean;
}

const COLOR: Record<OnlineOrderTagDef['color'], string> = {
  orange: 'bg-orange-100 text-orange-800 ring-orange-300',
  red: 'bg-red-100 text-red-800 ring-red-300',
  blue: 'bg-blue-100 text-blue-800 ring-blue-300',
  green: 'bg-green-100 text-green-800 ring-green-300',
  gray: 'bg-gray-100 text-gray-800 ring-gray-300',
};

// Read-only display badge for a tag. Pass `onRemove` to make it removable.
function OnlineOrderTagBadge(props: Props) {
  const size = props.size ?? 'md';
  return (
    <span
      className={classNames(
        'inline-flex items-center rounded-full font-medium ring-1 ring-inset',
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs',
        COLOR[props.tag.color],
      )}
    >
      {props.tag.label}
      {props.onRemove && (
        <button
          type="button"
          disabled={props.disabled}
          onClick={(e) => {
            e.stopPropagation();
            props.onRemove?.();
          }}
          aria-label={`Remove ${props.tag.label}`}
          className={classNames(
            'ml-1 -mr-0.5 rounded-full p-0.5 transition-colors hover:bg-black/10',
            props.disabled && 'cursor-not-allowed opacity-50',
          )}
        >
          <XMarkIcon className="h-3 w-3" />
        </button>
      )}
    </span>
  );
}

export default OnlineOrderTagBadge;
